import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./CarWash.css";
import PaymentOptionsList from "../payment-type/components/PaymentOptionsList";
import { useCarPayment } from "../payment-type/hooks/useCarPayment";
import { useUserTheme } from "src/shared/hooks/useUserTheme";

const CarPaymentType: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const { updatePayment } = useCarPayment(id);
  const { bgClass, fontClass} = useUserTheme();

  return (
    <div className="min-h-screen" style={{ background: "linear-gradient(135deg, #e0f2fe 0%, #f9fafb 100%)" }}>
      <div className="flex-1 p-6 mt-16">
        <div className="max-w-2xl mx-auto">
          {/* Main Content Card */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            {/* Header Row */}
            <div className={`${bgClass} ${fontClass} h-16 rounded-tl-[15px] rounded-tr-[15] relative flex items-center justify-center mb-2`}>
              {/* Back Button (Left) */}
              <button onClick={() => navigate(-1)} className="absolute left-0 flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors duration-200">
                <ArrowBackIcon className="w-5 h-5" />
                <span className="font-medium">Back</span>
              </button>\

              {/* Title Centered */}
              <h1 className="text-2xl font-bold text-gray-900">Payment Details</h1>
            </div>

            {/* Subtitle */}
            <p className="text-center text-gray-600 mb-8">Choose the payment option that fits your needs</p>

            {/* Payment Options List */}
            <PaymentOptionsList onSelect={updatePayment} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarPaymentType;
